module.exports = __webpack_public_path__ + "static/img/7.b62fe90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Seguro-Colectivo/7.png
// module id = HsK4
// module chunks = 0